import React, { useEffect, useRef, useState } from "react";
import useOutside from "../../hooks/outsideClick";
import { classHelper } from "../../utils/stringUtils";
import { CloseIcon, SearchIcon } from "../svg/Icons";
import * as Variable from "../../utils/variables";
import "./FilterBox.scss";
import { connect } from "react-redux";
import LoadingComponent from "../LoadingComponent/LoadingComponent";

const ViewMoreBox = ({
	ENV_NAME,
	className,
	open,
	onHide,
	onSave,
	filters,
	searchPlaceholder,
	data,
	checkAll,
	withCount,
	parent,
	isLoading = false,
    country,
    allCountry = false,
	...props
}) => {
	const [search, setSearch] = useState("");
	const [tempFilters, setTempFilters] = useState(null);
	const menuRef = useRef();

	useEffect(() => {
		if (open && filters) {
			setTempFilters(filters);
		}
		if (!open) {
			clearState();
		}
	}, [open, filters]);

	const clearState = () => {
		setSearch("");
		setTempFilters(null);
	};

	useOutside(menuRef, onHide);

	const onChangeField = (e, parent, radio = false, country, allCountry) => {
		let currName = e.target.name?.replace(`temp-${parent}`, "");
		if (parent) {
			if (radio) {
				setTempFilters((p) => ({ ...p, [parent]: e.target.id }));
			} else {
				// Special for Jakarta
				if (parent === "domestic" && currName?.toLowerCase()?.includes("jakarta")) {
					let hasJakartas = data
						?.find((j) => j?.id === "J")
						?.children?.filter((j) => j?.id?.toLowerCase()?.includes("jakarta"));

					if (currName === "Jakarta") {
						hasJakartas = hasJakartas?.reduce(
							(acc, curr) => ({ ...acc, [curr?.id]: e.target.checked }),
							{}
						);
					}

					setTempFilters((p) => ({
						...p,
						locations: {
							...p?.[parent],
							Jakarta: currName === "Jakarta" ? e.target.checked : false,
							...(currName === "Jakarta"
								? hasJakartas
								: {
										[currName]: e.target.checked,
								  }),
						},
					}));
				}
				setTempFilters((p) => ({
					...p,
					[parent]: {
						...p?.[parent],
						[parent + 'All']:
                        ((parent === "domestic" || parent === "abroad") && Object.values({
                            ...p[parent],
                            [currName]: e.target.checked,
                        }).every((e) => e === false)
                            ? true
                            : false),
                            // ...(p?.[parent]?.[parent + "All"] && !e.target.checked ? { [parent + "All"]: false } : {}),
                    ...(!allCountry &&  {[currName] : e.target.checked}),
                    ...((parent!== "domestic" || parent!== "abroad") && p?.[parent]?.[parent + "All"] && !e.target.checked ? { [parent + "All"]: false } : {}),
                    ...((parent==="abroad" && allCountry) && p?.[parent]?.[parent + "All"] && !e.target.checked ? { [parent + "All"]: false } : {}),
					},
                    ...(!allCountry  && parent==="abroad" &&   { 
                        allCities: {
                            ...p.allCities,
                            [country]: {
                                ...p.allCities?.[country],
                                [currName]: e.target.checked
                            }
                        }
                    }),
                    ...(allCountry &&  {
                        countryAll: {
                            ...p.countryAll,
                            [currName] : e.target.checked
                        },
                    }),
                    ...(!allCountry &&  {
                        countryAll: {
                            ...p.countryAll,
                            [country] : false
                        },
                    }),
				}));
			}
		} else {
			if (radio) {
				setTempFilters((p) => ({ ...p, [currName]: e.target.id }));
			} else {
				setTempFilters((p) => ({ ...p, [currName]: e.target.checked }));
			}
		}
	};

	return (
        open && (
            <div
                className={classHelper('view-more-box', className || '')}
                ref={menuRef}
                {...props}
            >
                <div className="vmb-header">
                    <div className="form-group search-bar mb-0">
                        <SearchIcon className="searchIcon" />
                        <input
                            type="text"
                            name="searchText"
                            value={search || ''}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder={
                                searchPlaceholder ||
                                Variable.SRC_PLACEHOLDER[ENV_NAME]
                            }
                        />
                    </div>
                    <button className="btn p-0 ms-sm" onClick={onHide}>
                        <CloseIcon stroke="#193560" />
                    </button>
                </div>
                {isLoading ? (
                    <LoadingComponent className="my-5" notFullScreen />
                ) : allCountry ? (
                    <div className="vmb-body">
                        {data
                            ?.filter((i) =>
                                i?.cities
                                    ? true
                                    : i?.country_name
                                          ?.toLowerCase()
                                          ?.includes(search?.toLowerCase())
                            )
                            ?.map((i) =>
                                i?.cities ? (
                                    i?.cities?.filter((j) =>
                                        j?.name
                                            ?.toLowerCase()
                                            ?.includes(search?.toLowerCase())
                                    )?.length > 0 ? (
                                        <React.Fragment
                                            key={i?.country_label}
                                            className="form-group mb-0 form-check"
                                        >
                                            <div className="d-flex vmb-body-heading gap-3 custom-control custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id={`${i?.country_label}`}
                                                    name={`${i?.country_label}`}
                                                    checked={
                                                        tempFilters
                                                            .countryAll?.[
                                                            i?.country_label
                                                        ] || false
                                                    }
                                                    onChange={(e) =>
                                                        onChangeField(
                                                            e,
                                                            'abroad',
                                                            false,
                                                            i?.country_label,
                                                            true
                                                        )
                                                    }
                                                    disabled={isLoading}
                                                />
                                                <label
                                                    className="form-check-label big-label"
                                                    htmlFor={i?.country_label}
                                                >
                                                    {i?.country_name}
                                                </label>
                                            </div>
                                            {i?.cities
                                                ?.filter((j) =>
                                                    j?.name
                                                        ?.toLowerCase()
                                                        ?.includes(
                                                            search?.toLowerCase()
                                                        )
                                                )
                                                ?.map((j) => (
                                                    <div
                                                        key={j?.name}
                                                        className="form-group mb-0 form-check"
                                                    >
                                                        <div className="custom-control custom-checkbox">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id={`temp-${parent}${j?.name}`}
                                                                name={`temp-${parent}${j?.name}`}
                                                                checked={
                                                                    tempFilters
                                                                        .countryAll?.[
                                                                        i
                                                                            ?.country_label
                                                                    ] ||
                                                                    tempFilters
                                                                        ?.abroad?.[
                                                                        `${j?.name}`
                                                                    ] ||
                                                                    false
                                                                }
                                                                onChange={(e) =>
                                                                    onChangeField(
                                                                        e,
                                                                        'abroad',
                                                                        false,
                                                                        i?.country_label
                                                                    )
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor={`temp-${parent}${j?.country_label}`}
                                                            >
                                                                {j?.name}
                                                                {withCount && (
                                                                    <span className="filter-count">{`(${j?.colleges_count})`}</span>
                                                                )}
                                                            </label>
                                                        </div>
                                                    </div>
                                                ))}
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment key={i?.id} />
                                    )
                                ) : (
                                    <div
                                        key={i?.id}
                                        className="form-group mb-0 form-check"
                                    >
                                        <div className="custom-control custom-checkbox">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id={`temp-${parent}${i?.id}`}
                                                name={`temp-${parent}${i?.id}`}
                                                checked={
                                                    tempFilters?.[parent]?.[
                                                        `${i?.id}`
                                                    ] ||
                                                    // ((parent !== 'domestic' && parent !== 'abroad') && (tempFilters?.[parent]?.[`${i?.id}`] ||
                                                    // tempFilters?.[parent]?.[`${parent}All`] ||
                                                    // tempFilters?.[`${i?.id}`] )
                                                    // ) ||
                                                    tempFilters?.[parent]?.[
                                                        `${i?.id}`
                                                    ] ||
                                                    tempFilters?.[parent]?.[
                                                        `${parent}All`
                                                    ] ||
                                                    tempFilters?.[`${i?.id}`] ||
                                                    false
                                                }
                                                onChange={(e) =>
                                                    onChangeField(e, parent)
                                                }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={`temp-${parent}${i?.id}`}
                                            >
                                                {i?.name}
                                                {withCount && (
                                                    <span className="filter-count">{`(${i?.count_majors})`}</span>
                                                )}
                                            </label>
                                        </div>
                                    </div>
                                )
                            )}
                    </div>
                ) : (
                    <div className="vmb-body">
                        {data
                            ?.filter((i) =>
                                i?.children
                                    ? true
                                    : i?.name
                                          ?.toLowerCase()
                                          ?.includes(search?.toLowerCase())
                            )
                            ?.map((i) =>
                                i?.children ? (
                                    i?.children?.filter((j) =>
                                        j?.name
                                            ?.toLowerCase()
                                            ?.includes(search?.toLowerCase())
                                    )?.length > 0 ? (
                                        <React.Fragment key={i?.id}>
                                            <div className="vmb-body-heading">
                                                {i?.name}
                                            </div>
                                            {i?.children
                                                ?.filter((j) =>
                                                    j?.name
                                                        ?.toLowerCase()
                                                        ?.includes(
                                                            search?.toLowerCase()
                                                        )
                                                )
                                                ?.map((j) => (
                                                    <div
                                                        key={j?.id}
                                                        className="form-group mb-0 form-check"
                                                    >
                                                        <div className="custom-control custom-checkbox">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id={`temp-${parent}${j?.id}`}
                                                                name={`temp-${parent}${j?.id}`}
                                                                checked={
                                                                    tempFilters
                                                                        ?.countryAll[
                                                                        country
                                                                    ] ||
                                                                    tempFilters?.[
                                                                        parent
                                                                    ]?.[
                                                                        `${j?.id}`
                                                                    ] ||
                                                                    false
                                                                }
                                                                onChange={(e) =>
                                                                    onChangeField(
                                                                        e,
                                                                        parent,
                                                                        false,
                                                                        country
                                                                    )
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor={`temp-${parent}${j?.id}`}
                                                            >
                                                                {j?.name}
                                                                {withCount && (
                                                                    <span className="filter-count">{`(${j?.colleges_count})`}</span>
                                                                )}
                                                            </label>
                                                        </div>
                                                    </div>
                                                ))}
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment key={i?.id} />
                                    )
                                ) : (
                                    <div
                                        key={i?.id}
                                        className="form-group mb-0 form-check"
                                    >
                                        <div className="custom-control custom-checkbox">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id={`temp-${parent}${i?.id}`}
                                                name={`temp-${parent}${i?.id}`}
                                                checked={
                                                    tempFilters?.[parent]?.[
                                                        `${i?.id}`
                                                    ] ||
                                                    // ((parent !== 'domestic' && parent !== 'abroad') && (tempFilters?.[parent]?.[`${i?.id}`] ||
                                                    // tempFilters?.[parent]?.[`${parent}All`] ||
                                                    // tempFilters?.[`${i?.id}`] )
                                                    // ) ||
                                                    tempFilters?.[parent]?.[
                                                        `${i?.id}`
                                                    ] ||
                                                    tempFilters?.[parent]?.[
                                                        `${parent}All`
                                                    ] ||
                                                    tempFilters?.[`${i?.id}`] ||
                                                    false
                                                }
                                                onChange={(e) =>
                                                    onChangeField(e, parent)
                                                }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={`temp-${parent}${i?.id}`}
                                            >
                                                {i?.name}
                                                {withCount && (
                                                    <span className="filter-count">{`(${i?.count_majors})`}</span>
                                                )}
                                            </label>
                                        </div>
                                    </div>
                                )
                            )}
                    </div>
                )}
                <div className="vmb-footer">
                    <button
                        className="btn btn-cta-secondary"
                        onClick={() => {
                            parent === 'domestic' || parent === 'abroad'
                                ? setTempFilters((p) => ({
                                      ...p,
                                      [parent]: { [parent + 'All']: true },
                                  }))
                                : setTempFilters((p) => ({
                                      ...p,
                                      [parent]: null,
                                  }))
                        }}
                    >
                        {Variable.RESET[ENV_NAME]}
                    </button>
                    <button
                        className="btn btn-cta-primary"
                        onClick={() => {
                            onSave(tempFilters)
                            onHide()
                        }}
                    >
                        {Variable.APPLY[ENV_NAME]}
                    </button>
                </div>
            </div>
        )
    )
};

const mapStateToProps = (state) => {
	return { ENV_NAME: state.auth.selectedEnvironment || "bhs" };
};

const mapStateToDispatch = (dispatch) => {
	return {};
};

export default connect(mapStateToProps, mapStateToDispatch)(ViewMoreBox);
